import React from "react";

export function PageHeader({ title, subtitle, actions, leftActions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-6">
      <div className="flex items-end gap-4">
        <div>
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-7 bg-brandred rounded-full inline-block" />
            <h1 className="font-display text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-navy">{title}</h1>
          </div>
          {subtitle && <p className="text-sm text-slate-500 mt-1 ml-3.5">{subtitle}</p>}
        </div>
        {leftActions && <div className="flex items-center gap-2 pb-0.5">{leftActions}</div>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, icon: Icon, tone = "navy", onClick, testid }) {
  const tones = {
    navy: "text-navy", red: "text-brandred", green: "text-successg", amber: "text-amberw", danger: "text-dangerr",
  };
  return (
    <button data-testid={testid} onClick={onClick} disabled={!onClick}
      className={`mb-card p-4 text-left transition-all duration-150 ${onClick ? "hover:shadow-md hover:-translate-y-0.5 cursor-pointer" : "cursor-default"}`}>
      <div className="flex items-center justify-between">
        <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">{label}</span>
        {Icon && <Icon className={`w-4 h-4 ${tones[tone]}`} />}
      </div>
      <div className={`font-num text-2xl sm:text-3xl font-bold mt-2 ${tones[tone]}`}>{value}</div>
    </button>
  );
}

export function Pill({ children, tone = "slate" }) {
  const map = {
    slate: "bg-slate-100 text-slate-700", navy: "bg-navy/10 text-navy", red: "bg-brandred/10 text-brandred",
    green: "bg-successg/10 text-successg", amber: "bg-amberw/10 text-amberw", danger: "bg-dangerr/10 text-dangerr",
    blue: "bg-blue-100 text-blue-700",
  };
  return <span className={`px-2.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-wide ${map[tone]}`}>{children}</span>;
}

export function Btn({ children, variant = "navy", className = "", testid, ...props }) {
  const v = {
    navy: "bg-navy hover:bg-navy-deep text-white border-navy",
    red: "bg-brandred hover:bg-brandred-dark text-white border-brandred",
    ghost: "bg-white hover:bg-slate-50 text-slate-800 border-slate-300",
  };
  return (
    <button {...props} data-testid={testid} className={`font-bold py-2.5 px-5 rounded-xl border-2 shadow-sm active:translate-y-px transition-all duration-150 flex items-center justify-center gap-2 text-sm disabled:opacity-60 ${v[variant]} ${className}`}>
      {children}
    </button>
  );
}
